import { getValidationResolver, useForm } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { VALIDATORS } from '@/common';
import { DEFAULT_DATE_FORMAT } from '@/common/constants';

import { ScheduledFormPayload } from '../../ScheduledReport.types';
interface Params {
  defaultValues: Partial<ScheduledFormPayload>;
}
const useScheduledReportForm = ({ defaultValues }: Params) => {
  const methods = useForm<ScheduledFormPayload>({
    resolver: getValidationResolver({
      name: VALIDATORS.REQUIRED_STRING,
      type: VALIDATORS.REQUIRED_STRING,
      cronString: VALIDATORS.STRING,
      startDate: VALIDATORS.REQUIRED_STRING,
      endDate: VALIDATORS.DATE_FORMAT_AFTER_OTHER_DATE(
        'startDate',
        // eslint-disable-next-line quotes
        "The end date couldn't be earlier than the start date"
      ),
    }),
    defaultValues: {
      startDate: dayjs().format(DEFAULT_DATE_FORMAT),
      ...defaultValues,
    },
  });

  return methods;
};
export default useScheduledReportForm;
